import { ITheme } from "../../utils/theme"

export const tableHeaderStyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold',
  marginTop: 4,
  marginBottom: 1,
}

export const subHeaderStyles = {
  color: (theme: ITheme) => theme.palette.blue[600],
  fontWeight: 'bold'
}

export const paginationStyles = {
  position: 'sticky',
  left: 0,
  width: 'inherit !important',
  '& .MuiPagination-ul': {
    justifyContent: 'center',
  },
  pt: 1,
  pb: 1
}